import script from "./EmptyBMs.vue?vue&type=script&lang=ts&setup=true"
export * from "./EmptyBMs.vue?vue&type=script&lang=ts&setup=true"

import "./EmptyBMs.vue?vue&type=style&index=0&id=6b3b814a&lang=sass"

const __exports__ = script;

export default __exports__